import { Spinner, Center } from '@chakra-ui/react';
import { useGetAuthorizedTabsSelector, useGetUserInfoSelector } from 'core/redux/selectors/authSelectors';
import { Route, Routes } from 'react-router';
import { RouteDec } from 'types';
import UnauthorizedAccess from 'pages/UnauthorizedAccess';

import routesMapper from './routesMapper';
import Home from 'pages/Home';
import useNotifications from 'hooks/useNotifications';

const mapRoutes = (routes: RouteDec, authorizedTabs: string[], forceActive = false) => {
    return Object.entries(routes)
        .map(([key, route]) => {
            const Component = route.element;
            const routeChildren =
                (authorizedTabs.includes(key) || forceActive) && route.children
                    ? route.children.map((childRoute) => mapRoutes(childRoute, authorizedTabs, true))
                    : null;
            const isRootObj = key === 'root' ? { element: <Component /> } : { path: route.path };
            if (authorizedTabs.includes(key) || forceActive) {
                if (routeChildren) {
                    return (
                        <Route key={key} {...isRootObj}>
                            {key !== 'root' && <Route index element={<Component />} />}
                            {key === 'root' && <Route index element={<Home />} />}
                            {routeChildren}
                        </Route>
                    );
                }

                return <Route key={key} path={route.path} element={<Component />} />;
            }

            return null;
        })
        .filter((r) => r !== null);
};

const Router = () => {
    const { authorizedTabs, isLoading: areTabsLoading } = useGetAuthorizedTabsSelector();
    const userInfo = useGetUserInfoSelector();
    useNotifications(userInfo);

    if (areTabsLoading) {
        return (
            <Center h="100%">
                <Spinner speed="0.65s" emptyColor="gray.200" color="blueMain" size="xl" />
            </Center>
        );
    }
    if (authorizedTabs.length === 0) {
        return <UnauthorizedAccess />;
    }
    return (
        <Routes>
            {mapRoutes(routesMapper, [...authorizedTabs, 'pdp', 'root', 'home', 'sales-data'])}
            <Route path="*" element={<UnauthorizedAccess />} />
        </Routes>
    );
};

export default Router;
